import React from 'react';
import TextField from '@mui/material/TextField';
import '../../App.css';
import setSearchCreateDateFromAction from '../../redux/actions/searchReferenceActions/actionSearchCreateDateFrom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchCreateDateAndTime extends React.Component {

    constructor(props) {
        super(props);
        this.state = { dateFrom: ''};
        this.props.setSearchCreateDateFromFunction(this.state.dateFrom);
        this.handleChangeFrom = this.handleChangeFrom.bind(this);

        this.props.setSearchCreateDateFromFunction('');
    }

    handleChangeFrom(event) {
        // console.log(today())

        this.setState({ dateFrom: event.target.value }, () => {
           this.props.setSearchCreateDateFromFunction(this.state.dateFrom);
            // console.log(this.state.dateFrom);
        });
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <div className='datePickerCreateFrom'>
                    <form className={'datepickerCreateFrom'} noValidate onChange={this.handleChangeFrom}>
                        <StyledTextField
                        classes={classes}
                            id="dateCreateFrom"
                            style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)', marginBottom: '10px' }}
                            label={t("search_ref.search_date_created_on")}
                            type="date"
                            variant="outlined"
                            defaultValue={''}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
return{
    setSearchCreateDateFromFunction: searchCreateDateFrom => {
        dispatch(setSearchCreateDateFromAction(searchCreateDateFrom))
    }
}
}
export default connect(null, mapDispatchToProps)(withTranslation()(SearchCreateDateAndTime)); 